import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { FetchStatus, ProfileState } from 'state/types'
import { accountApi, authApi } from 'restApi'
import { Distribution } from 'restApi/openapi'
import cloneDeep from 'lodash-es/cloneDeep'

const initialState: ProfileState = {
  sessionFetchStatus: FetchStatus.NOT_FETCHED,
  authentication: null,
  accountInfoFetchStatus: FetchStatus.NOT_FETCHED,
  accountInfo: {
    address: '',
    distribution: Distribution.RANDOM,
    referredBy: 0,
    referralId: 0,
    userId: 0,
  },
}

export const fetchSession = createAsyncThunk('profile/fetchSession', async () => {
  try {
    const { authentication: session } = await authApi.getSession()
    return { session }
  } catch (error) {
    console.error('Failed to fetch session', error)
    throw error
  }
})

export const fetchAccountInfo = createAsyncThunk('profile/fetchAccountInfo', async () => {
  try {
    const accountInfo = await accountApi.getAccountInfo()
    return { accountInfo }
  } catch (error) {
    console.error('Failed to fetch account info', error)
    throw error
  }
})

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    profileClear: () => cloneDeep(initialState),
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSession.pending, (state) => {
      state.sessionFetchStatus = FetchStatus.FETCHING
    })
    builder.addCase(fetchSession.fulfilled, (state, action) => {
      state.sessionFetchStatus = FetchStatus.FETCHED
      state.authentication = action.payload.session
    })
    builder.addCase(fetchSession.rejected, (state) => {
      state.sessionFetchStatus = FetchStatus.FAILED
      state.authentication = null
    })
    builder.addCase(fetchAccountInfo.pending, (state) => {
      state.accountInfoFetchStatus = FetchStatus.FETCHING
    })
    builder.addCase(fetchAccountInfo.fulfilled, (state, action) => {
      const { address, distribution = Distribution.RANDOM, referredBy, referralId, userId } = action.payload.accountInfo

      state.accountInfoFetchStatus = FetchStatus.FETCHED
      state.accountInfo.address = address
      state.accountInfo.distribution = distribution
      state.accountInfo.referredBy = referredBy
      state.accountInfo.referralId = referralId
      state.accountInfo.userId = userId
    })
    builder.addCase(fetchAccountInfo.rejected, (state) => {
      state.accountInfoFetchStatus = FetchStatus.FAILED
      state.accountInfo.address = ''
      state.accountInfo.distribution = Distribution.RANDOM
      state.accountInfo.referredBy = 0
      state.accountInfo.referralId = 0
      state.accountInfo.userId = 0
    })
  },
})

// Actions
export const { profileClear } = profileSlice.actions

export default profileSlice.reducer
